module.exports = "https://img1.huilianyi.com/d/icon-wechat.d23de60b58.appcore.png";